import { gql } from '@apollo/client';

export const MAP_RESULT = gql`
  query MapResults($id: ID!) {
    mapResult(id: $id) {
      id
      map
      snapshot
      plan
      user
    }
  }
`;

export const MAP_RESULTS = gql`
  query MapResults {
    mapResults {
      id
      map
      snapshot
      plan
      user
    }
  }
`;

export const MAP_USER_RESULTS = gql`
  query MyMapResults($user: ID!) {
    mapUserResults(user: $user) {
      id
      map
      snapshot
      plan
      user
      meta
      photos
      planSVG
      planTitle
    }
  }
`;
